var scrollPosition = 0;
/**
 * Detects if the device is iOS, which needs to be handled differently than other devices
 * Taken directly from the `body-scroll-lock` repo
 *
 * @link {https://github.com/willmcpo/body-scroll-lock/blob/master/src/bodyScrollLock.js#L28}
 */
export var isIosDevice = function () {
    if (typeof window === 'undefined')
        return false;
    var navigator = window.navigator;
    if (!navigator || !navigator.platform)
        return false;
    var isIosPlatform = /iP(ad|hone|od)/.test(navigator.platform);
    var isMacWithTouch = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return isIosPlatform || isMacWithTouch;
};
/**
 * Creates a style tag to lock scrolling
 *
 * @returns {HTMLElement}
 */
export var createInlineStyleSheet = function () {
    var styleTag = document.createElement('style');
    var styles;
    if (isIosDevice()) {
        styles = "position: fixed; top: -".concat(scrollPosition, "px; left: 0; right: 0;");
    }
    else {
        styles = 'overflow: hidden;';
    }
    // stop bouncing by adding the overscroll-behavior ony for when a Modal is open
    var css = "body { ".concat(styles, " } html { overscroll-behavior: none; }");
    styleTag.innerText = css;
    styleTag.classList.add('scroll-lock');
    return styleTag;
};
export var getInlineStyleSheet = function () { var _a; return ((_a = document.querySelector('head')) === null || _a === void 0 ? void 0 : _a.querySelector('style.scroll-lock')) || null; };
/**
 * Applies an inline style sheet that locks scrolling on the page
 *
 * @param {Number} scrollPosition - the y offset in pixels of the page
 * @returns {Void}
 */
export var disableBodyScroll = function () {
    var scrollLockStyle = getInlineStyleSheet();
    scrollPosition = window.pageYOffset;
    if (!scrollLockStyle) {
        var headElement = document.querySelector('head');
        if (headElement) {
            headElement.appendChild(createInlineStyleSheet());
        }
    }
};
/**
 * Removes a inline style sheet that locks scrolling on the page
 *
 * @param {Number} scrollPosition - the y offset in pixels of the page
 * * @returns {Void}
 */
export var enableBodyScroll = function () {
    var scrollLockStyle = getInlineStyleSheet();
    if (scrollLockStyle) {
        scrollLockStyle.remove();
        if (isIosDevice() && scrollPosition !== undefined)
            window.scrollTo(0, scrollPosition);
    }
};
export var bodyScrollLockExists = function () {
    return !!document.querySelectorAll('.body-scroll-lock').length;
};
export default {};
